import { isNil, noop, stubFalse } from 'lodash';
import { gtmTracker } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { performanceMetricDataApi } from 'services/api/performanceMetricDataApi/performanceMetricDataApi';
import { IS_DEBUG_MODE } from '../../../../services/isDebugMode';
import { getTraceMetricAttributes } from '../utils/getTraceMetricAttributes';
import { getTraceProcessingTime } from '../utils/getTraceProcessingTime';
import { TRACER_STATUS_CODE } from '../utils/statusCode';
import { SPAN_SCOPE } from './spanScope';

const NANO_COEFFICIENT = 1_000_000_000;
const TIMEOUT_THRESHOLD = 110 * NANO_COEFFICIENT;
const VALUABLE_SKIP_THRESHOLD = 5 * NANO_COEFFICIENT;

export class CustomSpanMetricProcessor {
    constructor(normalizeSpanAttributes = stubFalse) {
        this.normalizeSpanAttributes = normalizeSpanAttributes;
        this.onStart = noop;
    }

    onEnd(span) {
        if (!SPAN_SCOPE[span.name] || !isNil(span.parentId) || !span.attributes) {
            return;
        }

        // We use UNSET when report fetching skipped
        const processingTime = getTraceProcessingTime(span);
        if (span.status.code === TRACER_STATUS_CODE.UNSET && processingTime < VALUABLE_SKIP_THRESHOLD) {
            return;
        }

        const transformedSpan = this.normalizeSpanAttributes(span);
        if (!transformedSpan) {
            return;
        }

        if (processingTime > TIMEOUT_THRESHOLD) {
            const errorMessage = `Span duration is more than timeout threshold (reportId-${
                span?.attributes?.reportId
            }, spanId-${span?._spanContext?.spanId}, traceId-${span?._spanContext?.traceId}): ${(
                processingTime / NANO_COEFFICIENT
            ).toFixed(2)}s`;
            gtmTracker.trackError(new Error(errorMessage));
            if (IS_DEBUG_MODE()) {
                console.error(errorMessage);
            }
        }

        const metricAttributes = getTraceMetricAttributes(transformedSpan);

        performanceMetricDataApi.updatePerformanceMetricData({
            value: processingTime,
            labelData: metricAttributes,
        });
    }
}
